module.exports = __webpack_public_path__ + "img/algovision-full-logo-small.2c33d001.png";